
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/profile-scott-sunderland",
      function () {
        return require("private-next-pages/about/profile-scott-sunderland.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/profile-scott-sunderland"])
      });
    }
  